import React from "react";

/**
 * SuggestionChips Component
 * Renders clickable suggestion chips at the bottom of a response
 */
const SuggestionChips = ({ chips, onSuggestionClick, disabled }) => {
  if (!chips || chips.length === 0) return null;

  return (
    <div className="suggestion-chips">
      {chips.map((chip, index) => (
        <button
          key={index}
          onClick={() => onSuggestionClick?.(chip)}
          disabled={disabled}
          className="suggestion-chip"
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
};

export default SuggestionChips;
